module.exports = __webpack_public_path__ + "static/media/melbourne-logo.77c008a5.svg";